<template>
    <div class="plan-item-button" :class="{ selected: isSelected }" @click="$emit('click')">
        <slot />
    </div>
</template>
<script>
export default {
    name: "PlanItemButton",
    props: {
        isSelected: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
<style lang="scss" scoped>
.plan-item-button {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px 12px;
    border-radius: 16px;
    cursor: pointer;
    background: #F1F4F7;
    border: 1px solid #F1F4F7;
    color: #222222;
    gap: 5px;
    font-size: 12px;

    &:hover {
        background: #1C1B1F;
        border: 1px solid #1C1B1F;
        color: white;

        .material-icons {
            color: white;
        }
    }

    &.selected {
        background: #F1F4F7;
        border: 1px solid #E4D7FF;
        color: #5625CC;

        .material-icons {
            color: #5625CC;
        }
    }

    .material-icons {
        font-size: 16px;
        color: #222222;
    }
}
</style>
